module.exports = "/images/vendor/flag-icon-css/flags/4x3/tv.svg?829fb9d89912457f171d40d33805a83e";